module.exports = __webpack_public_path__ + "img/SORIANA.5523245d.png";